import React, { FC } from 'react';
import { Text } from 'components/Typography';
import { FontWeights, Colors } from 'core/CssVariables';
import { useUserTimezone } from 'hooks/useGetDateWithTimeZone';
import { SSeconds, STimezoneText } from './TimeTracker.style';

type TTimeTrackerTimerProps = {
  hours: number;
  minutes: number;
  seconds: number;
  showTimezone?: boolean;
};
const TimeTrackerTimer: FC<TTimeTrackerTimerProps> = ({
  hours,
  minutes,
  seconds,
  showTimezone = false,
}) => {
  const { abbreviation } = useUserTimezone();

  return (
    <Text
      fontlevel={5}
      fontWeight={FontWeights.SemiBold}
      className="mx-2"
      style={{ whiteSpace: 'nowrap' }}
    >
      {hours < 10 && 0}
      {hours}:{minutes < 10 && 0}
      {minutes}
      <SSeconds fontlevel={5}>
        :{seconds < 10 && 0}
        {seconds}
      </SSeconds>
      {showTimezone && (
        <STimezoneText fontlevel={6} color={Colors.LightGrey}>
          {abbreviation}
        </STimezoneText>
      )}
    </Text>
  );
};

export default TimeTrackerTimer;
